// Pure Master-Detail-Logik der Mail-Seite für die Mobile-Shell (<640):
// welcher Bereich (Ordner → Liste → Nachricht) gerade aktiv ist und welcher
// Titel in der Top-Mitte steht. Aus mail.tsx herausgezogen, damit die
// Weiche ohne DOM testbar ist (mail-mobile.test.ts). Die Sichtbarkeits-
// Klassen der drei Panes in mail.tsx folgen exakt derselben Priorität:
// Nachricht schlägt Liste schlägt Ordner.

export type MailMobileArea = 'folders' | 'list' | 'message'

export function resolveMailArea(opts: {
  activeAccountId: string | null
  activeMessageId: string | null
  /** Sammelposteingang „Alle" (#535): die Liste steht ohne Einzelkonto. */
  unified?: boolean
}): MailMobileArea {
  if (opts.activeMessageId) return 'message'
  if (opts.activeAccountId || opts.unified) return 'list'
  return 'folders'
}

/** Titel des Listen-Bereichs — gleiche Priorität wie der Listen-Header in
 *  mail.tsx (Suche > Entwürfe > Ordner); Ordner-Pfade werden auf den
 *  Anzeigenamen gemappt (Fallback: roher Pfad, bevor die Ordner geladen sind). */
export function mailListTitle(opts: {
  /** Debounced Suchbegriff; '' = keine aktive Suche. */
  searchTerm: string
  /** Lokaler Entwürfe-Pseudo-Ordner (DRAFTS_VIEW) aktiv? */
  draftsView: boolean
  folderPath: string
  folders: ReadonlyArray<{ path: string; name: string }>
}): string {
  if (opts.searchTerm) return `Suche: ${opts.searchTerm}`
  if (opts.draftsView) return 'Entwürfe'
  return opts.folders.find((f) => f.path === opts.folderPath)?.name ?? opts.folderPath
}
